<template>
  <div class="config-layout">
    <TopBarTitleComponent title="Configuraciones" :showBackIcon="true">
      <template slot="right-area"></template>
    </TopBarTitleComponent>

    <div class="config-content-body">
      <b-container fluid>
        <b-row>
          <b-col sm="12" md="12" lg="12">
            <div
              class="box-shadow border-radius p-3 mb-3 bg-color-write wrapper__cotent-tabs config-tabs-card"
            >
              <el-tabs v-model="activeName">
                <el-tab-pane
                  label="Servidor de Correo"
                  name="email"
                  class="p-4"
                >
                  <PreferencesEmailComponent />
                </el-tab-pane>
                <el-tab-pane
                  label="Diseño de plantillas"
                  name="design"
                  class="p-4"
                >
                  <TemplateDesignComponent />
                </el-tab-pane>
                <el-tab-pane
                  label="Notificaciones"
                  name="notifications"
                  class="p-4"
                >
                  <NotificationTemplatesComponent />
                </el-tab-pane>
                <el-tab-pane label="Mensajes" name="messages" class="p-4">
                  <PreferencesMessagesComponent />
                </el-tab-pane>
                <el-tab-pane
                  label="Términos y Condiciones"
                  name="legal"
                  class="p-4"
                >
                  <PreferencesLegalComponent />
                </el-tab-pane>
                <el-tab-pane
                  label="Cobros y recordatorios"
                  name="collection"
                  class="p-4"
                  lazy
                >
                  <CollectionSettingsComponent v-if="activeName === 'collection'" />
                </el-tab-pane>
              </el-tabs>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <OnBoardComponent :show.sync="showOnBoard" v-if="showOnBoard" />
  </div>
</template>

<script>
import TopBarTitleComponent from "../../components/TopBarTitle";
import PreferencesLegalComponent from "./preferences/InformationLegal";
import PreferencesMessagesComponent from "./preferences/Messages";
import PreferencesEmailComponent from "./preferences/Email";
import TemplateDesignComponent from "./preferences/TemplateDesign";
import NotificationTemplatesComponent from "./preferences/NotificationTemplates";
import CollectionSettingsComponent from "./preferences/CollectionSettings";
import OnBoardComponent from "../../components/OnBoard";

export default {
  name: "ConfigurationsMainComponent",
  data: () => ({
    activeName: "email",
    showOnBoard: false
  }),
  mounted() {
    // Permitir llegar directo a un tab via ?tab=collection (etc.)
    if (this.$route && this.$route.query && this.$route.query.tab) {
      this.activeName = this.$route.query.tab;
    }
  },
  methods: {
    handleShowOnBoard() {
      this.showOnBoard = !this.showOnBoard;
    }
  },
  components: {
    TopBarTitleComponent,
    PreferencesLegalComponent,
    PreferencesMessagesComponent,
    PreferencesEmailComponent,
    TemplateDesignComponent,
    NotificationTemplatesComponent,
    CollectionSettingsComponent,
    OnBoardComponent
  }
};
</script>

<style lang="scss" scoped>
.config-layout {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.config-content-body {
  padding: 1rem 0 2rem;
}

// Scroll horizontal silencioso en responsive (sin ocultar la línea base)
.config-tabs-card {
  ::v-deep .el-tabs__nav-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  // Separación consistente en todos los labels del módulo
  ::v-deep label {
    margin-bottom: 10px !important;
  }
}
</style>
